import React, { useEffect, useState } from "react";
import ManagerCommuteStaticsCalendar from "../components/ManagerCommuteStaticsCalendar";
import config from "../config/config";
import {useUser} from "../context/UserContext";
const API_URL = config.API_URL;


function ManagerCommuteStatics({showCompanyList = false}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const {authority, company} = useUser();
  const currentDate = new Date();
  const userTable = !showCompanyList; 
  // const startupManager = (authority <= 4);

  const formatDate = (date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  };

  const [currentMonth, setCurrentMonth] = useState(
    formatDate(new Date(
      currentDate.getFullYear(), currentDate.getMonth(), 1
    ))
  );
  
  const handlePrevMonth = () => {
    const dummyDate = new Date(currentMonth);

    // console.log(dummyDate.getFullYear(), dummyDate.getMonth(), dummyDate.getDay());
    const prevMonth = new Date(dummyDate.getFullYear(), dummyDate.getMonth() - 1, 1);
    // console.log(prevMonth);
    // console.log(formatDate(prevMonth));
    setCurrentMonth(formatDate(prevMonth));
  };

  const handleNextMonth = () => {
    const dummyDate = new Date(currentMonth);
    const nextMonth = new Date(dummyDate.getFullYear(), dummyDate.getMonth() + 1, 1);

    setCurrentMonth(formatDate(nextMonth));
  };

  // API 호출 함수
  const fetchData = async (currentMonth) => {
    try {
      const response = await fetch(`${API_URL}/api/commute/getMonthlyCommuteStatistics`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body:JSON.stringify({
          target_month: currentMonth,
          showCompanyList: showCompanyList //회사 리스트인지 아닌지
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // console.log(result.value);

      if (result.result) {
        // 데이터를 변환하여 company -> startup_name 매핑
        const formattedData = result.value;
        setData(formattedData);
      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      // setError(error.message); // 에러 메시지 저장
    } finally {
      setLoading(false); // 데이터 로딩 완료
    }
  };
  // useEffect(() => {
  //   fetchData(currentDate);
  // }, []);

  useEffect(() => {
    const fetchDataAsync = async () => {
      // setLoading(true);
      await fetchData(currentMonth);
    };
    fetchDataAsync();
  }, [currentMonth]);

  // const data = [
  //   {
  //     company: "스밈팩토리",
  //     result: [
  //       { date: "2025-02-01", check: "true" },
  //       { date: "2025-02-02", check: "false" },
       
  //     ],
  //   },
  //   {
  //     company: "서울테크트리",
  //     result: [
  //       { date: "2025-02-01", commute: "false" },
  //       { date: "2025-02-02", commute: "true" },
  //     ],
  //   },
  // ];

  return (
    <div style={styles.main}>
      {loading ? (
        <p>Loading...</p>
      ) :(
        <ManagerCommuteStaticsCalendar commuteData={data} currentDate={currentMonth} handleNextMonth={handleNextMonth} handlePrevMonth={handlePrevMonth}
          userTable={userTable}
          onDataUpdate={() => fetchData(currentMonth)}
          authority={authority}
          />
      )}
    </div>
  );  
}
const styles ={
  main :{
    display: "flex",
    gap: "20px",
    flexDirection: "column",
    flex: "1",
    padding: "16px"
  },
  topLine:{
    display: "flex",
    gap: "20px",
    height: "424px"
  },
  bottomLine:{
    display: "flex",
    flex: "1",
    gap: "20px"
  }
}

export default ManagerCommuteStatics;